module.exports = __webpack_public_path__ + "img/限时商品9.5191ba6d.png";